/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckNumber/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function CheckNumber({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget/Check/CheckNumber",
  onChange
  
}) {
let payersActivetabDownpaymentMetadataCheckNumberValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.downpayment_metadata.check.number',
})
let payersActivetabDownpaymentMetadataCheckNumberChangeData = fromData.useDataChange({ viewPath,
context: 'payers',
path: 'activeTab.downpayment_metadata.check.number',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 borderColor={dtColorsNeutral200}
 backgroundColor="white"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 label="Check number"
 placeholder="1732..9187"
 data="payers.activeTab.downpayment_metadata.check.number"
 value={payersActivetabDownpaymentMetadataCheckNumberValueData}
 onChange={payersActivetabDownpaymentMetadataCheckNumberChangeData}
/>
{children}
</React.Fragment>)
}